export default "__VITE_ASSET__BikqzYJZ__"